export interface MedisanteTargetSystem {
  readonly id: string;
  readonly name: string;
  readonly url: string;
  readonly format?: string;
  readonly deviceCount?: number;
  readonly isMutable?: boolean;
  readonly owner?: string;
  readonly lastStatusCode?: number;
  readonly lastStatusUpdate?: string;
  authType?: string;
  authData?: AuthData;
  isDefault: boolean;
  readonly count?: number;
  readonly testCount?: number;
  deactivated?: boolean;
  allowIP?: string;
}

export interface AuthData {
  authEndpoint: string;
  grantType: string;
  username: string;
  code: string;
  redirectURI: string;
}

export interface Filter {
  key: string;
  name: string;
  value: string;
  label: string;
  active: boolean;
  disabled: boolean;
  measurements?: string[];
}

export enum TargetSystemsSortBy {
  NAME = 'NAME',
  URL = 'URL',
  DEVICECOUNT = 'DEVICECOUNT',
  LASTSTATUSCODE = 'LASTSTATUSCODE',
  REQUESTS = 'REQUESTS',
  REQUESTS_TEST = 'REQUESTS_TEST',
}
